import script from "./BeamTableCell.vue?vue&type=script&setup=true&lang=js"
export * from "./BeamTableCell.vue?vue&type=script&setup=true&lang=js"

import "./BeamTableCell.vue?vue&type=style&index=0&id=449ca900&lang=css"

const __exports__ = script;

export default __exports__